import React from 'react';
import styled from 'styled-components';
import { FlexContainer } from 'app/styles/content';
import { COLORS, SIZES, Typography } from '@fupa/fupa-uikit';
const EventInformation = styled(FlexContainer).withConfig({
  componentId: "sc-kfp0md-0"
})(["align-self:start;flex-direction:column;align-items:center;min-width:3rem;background:", ";border-bottom-right-radius:0.5rem;border-top-left-radius:0.5rem;padding:0 0.5rem;"], props => props.customBgColor ? props.customBgColor : COLORS.lightGrey);
const Minute = styled(Typography).withConfig({
  componentId: "sc-kfp0md-1"
})(["line-height:", ";&&&{color:", ";}"], SIZES['24'], props => props.customBgColor ? COLORS.white : COLORS.darkestGrey);
const MatchEventMinute = _ref => {
  let {
    minute,
    customBgColor,
    className
  } = _ref;
  const label = minute === "0'" ? 'vor Spielbeginn' : minute;
  return /*#__PURE__*/React.createElement(EventInformation, {
    className: className,
    customBgColor: customBgColor,
    "data-sentry-element": "EventInformation",
    "data-sentry-component": "MatchEventMinute",
    "data-sentry-source-file": "MatchEventMinute.tsx"
  }, /*#__PURE__*/React.createElement(Minute, {
    customBgColor: customBgColor,
    variant: "button-sub",
    component: "span",
    "data-sentry-element": "Minute",
    "data-sentry-source-file": "MatchEventMinute.tsx"
  }, label));
};
export default MatchEventMinute;